import { Component, OnInit, ViewChild } from '@angular/core';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { IOption } from 'ng-select';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Upload } from 'app/uploads/shared/upload';
import { UploadService } from 'app/uploads/shared/upload.service';
import * as firebase from 'firebase/app';
import { HRMSService } from '../shared/hrms.service';
import { UtilService } from '../shared/util.service';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SessionService } from 'app/sessions/session.service';
import { UserService } from 'app/users/shared/user.service';
import { filterBy } from '@progress/kendo-data-query';
import { DateService } from 'app/date/date.service';
@Component({
  selector: 'app-leaves',
  templateUrl: './leaves.component.html',
  styleUrls: ['./leaves.component.css'],
  animations: [fadeInOutTranslate],
  providers: [DatePipe,UploadService]
})
export class LeavesComponent implements OnInit {
  myForm:FormGroup;
  searchForm: FormGroup;
  adminSearchForm: FormGroup;
  public gridView: GridDataResult;
  public gridViewAllLeaveList:GridDataResult;
  departmentsOptions: Array<IOption> = [];
  designationsOptions: Array<IOption> = [];
  myEmployees: Array<IOption> = [];
  departments:any;
  designations:any;
  public skip1 = 0;
  public pageSize = 10;
  public skip2 = 0;
  bsValue = new Date();
  searchResult:any;
  adminSearchResult:any;
  @ViewChild("ApplyLeaveModal") ApplyLeaveModal;
  leaveOptions: Array<IOption> = [
    {label: 'Casual', value: 'Casual Leave'},
    {label: 'Sick', value: 'Sick Leave'},
    {label: 'Loss of Pay', value: 'Loss of Pay'}
  ];
  statusOptions: Array<IOption> = [
    {label: 'Approved', value: 'Approved'},
    {label: 'Rejected', value: 'Rejected'},
    {label: 'Pending', value: 'Pending'}
  ];
  submitted:boolean = false;
  submittedSearch:boolean = false;
  selectedFiles: FileList;
  myLeavesList:any;
  myLeavesListGrid:any;
  employeeLeavesListGrid:any;
  gridDataFor30days:any;
  gridDataOfEmployeesFor30days:any;
  show: boolean = false;
  showPopup: boolean = false;
  clickedId:any;
  @ViewChild('ApplyLeaveModal') leavesModal;
  currentUpload: Upload;
  fromMinDate: Date;
  toMinDate: Date;
  edit:boolean = false;
  leaveId: any;
  isSearch:boolean = false;
  isSearchAdmin:boolean = false;
  constructor(private datePipe: DatePipe, private uploadService:UploadService, private hrmsService:HRMSService, private util:UtilService, private dateService:DateService, private ss:SessionService, private userService:UserService) { 
    this.fromMinDate = new Date();
    this.toMinDate = new Date();
    this.fromMinDate.setDate(this.fromMinDate.getDate());
    this.toMinDate.setDate(this.toMinDate.getDate());
    //console.log("diff",this.util.getDayDifference(this.toMinDate,this.fromMinDate));
  }

  ngOnInit() {
    this.initializeForm();
    this.getMyLeaveList();
    this.getAllDepartments();
    this.getAllDesignations();
    this.getAllEmployees();
    if(this.ss.getUserRole === 'admin' || this.ss.getUserRole === 'super admin')
    {
      this.getEmployeesLeaveList();
    }
  }
  public initializeForm()
  {
    this.myForm = new FormGroup({
      from: new FormControl(this.bsValue,Validators.required),
      to: new FormControl(this.bsValue,Validators.required),
      comments: new FormControl('',Validators.required),
      leaveType: new FormControl('',Validators.required),
      documentUrl: new FormControl(''),
      status: new FormControl('Pending',Validators.required)
    });

    this.searchForm = new FormGroup({
      from: new FormControl(''),
      to: new FormControl(''),
      status: new FormControl('',Validators.required)
    });
    this.searchForm.reset();
    this.adminSearchForm = new FormGroup({
      name: new FormControl(''),
      from: new FormControl(''),
      to: new FormControl(''),
      status: new FormControl(''),
      department: new FormControl(''),
      designation: new FormControl('')
    });
    this.adminSearchForm.reset();
  }
  public onSubmit()
  {
    this.submitted = true;
    //console.log(this.myForm.value);
    
    if(this.myForm.valid && !this.edit)
    {
      if(this.selectedFiles!=null)
      {
      this.uploadFile(localStorage.getItem('courierapp_user_id'));
      }
      else
      {
        this.applyLeave(null);
      }
    }
    else if(this.myForm.valid && this.edit)
    {
      if(this.selectedFiles!=null)
      {
        this.uploadFile(localStorage.getItem('courierapp_user_id'));
      }
      else
      {
        var data = this.myForm.value;
        data.from = this.dateService.getDate(this.myForm.value.from);
        data.to = this.dateService.getDate(this.myForm.value.to);
        data.uid = this.ss.getUserId;
        data.documentUrl = '';
        data.updatedAt = this.dateService.getTimeandDate().timeStamp;
        data.notif = "unread";
        this.updateLeave(data);
      }
    }
  }
public detectFiles(event) {
  this.selectedFiles = event.target.files;
  this.readUrl(event);
  }
  public readUrl(event:any) {
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    reader.onload = (event:any) => {
      //this.imageToUpload = event.target.result;
    } 
    reader.readAsDataURL(event.target.files[0]);
  }
}
private uploadFile(uid:string):void{
  let file = this.selectedFiles.item(0);
  this.currentUpload = new Upload(file);
  var uploadTask=this.uploadService.uploadFile(this.currentUpload,uid,file.name);
  uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
    (snapshot) =>  {
      // upload in progress
      this.currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
    },
    (error) => {
      // upload failed
      console.log(error);
    },
    () => {
      // upload success
      this.currentUpload.url = uploadTask.snapshot.downloadURL;
      this.currentUpload.name = this.currentUpload.file.name;
      this.applyLeave(this.currentUpload);
      //console.log("uploaded "+this.currentUpload.url);
    }
  );
}
applyLeave(currentUpload)
{
  if(!this.edit)
  {
    var data = this.myForm.value;
    //data.from = this.util.getDate(this.myForm.value.from).date;
    //data.to = this.util.getDate(this.myForm.value.to).date;
    data.from = this.dateService.getDate(this.myForm.value.from);
    data.to = this.dateService.getDate(this.myForm.value.to);
    data.documentUrl = currentUpload?currentUpload.url:'';
    data.requestedOn = this.dateService.getTodaysDate();
    data.uid = this.ss.getUserId;
    data.createdAt = this.dateService.getTimeandDate().timeStamp;
    data.updatedAt = this.dateService.getTimeandDate().timeStamp;
    data.notif = "unread";
    this.hrmsService.applyLeave(data).then(()=>{
      this.currentUpload = null;
      this.leavesModal.hide();
      this.submitted = false;
      this.myForm.reset();
      this.selectedFiles = null;
      this.edit = false;
      this.setFormValues();
    });
  }
  else
  {
    //console.log("edit data",data);
    var data = this.myForm.value;
    //data.from = this.util.getDate(this.myForm.value.from).date;
    //data.to = this.util.getDate(this.myForm.value.to).date;
    data.from = this.dateService.getDate(this.myForm.value.from);
    data.to = this.dateService.getDate(this.myForm.value.to);
    data.documentUrl = currentUpload?currentUpload.url:'';
    data.updatedAt = this.dateService.getTimeandDate().timeStamp;
    data.notif = "unread";
    //console.log("leave data",data);
    this.updateLeave(data);
  }
}
private getMyLeaveList()
{
  var leaveList = this.hrmsService.getMyLeaveList(this.ss.getUserId);
  leaveList.snapshotChanges().subscribe(item=>{
    this.myLeavesList = [];
    this.myLeavesListGrid = [];
    this.gridDataFor30days = [];
    item.forEach(element =>{
      var y = element.payload.toJSON();
      //console.log("item",y);
        y["key"] = element.key;
        this.myLeavesList.push(y);
        var object = {
          "RequestedOn": this.dateService.getFullDate(element.payload.child("requestedOn").val()),
          "RequestedOnDate": element.payload.child("requestedOn").val(),
          "LeavePeriod": this.dateService.getFullDate(element.payload.child("from").val()) +" - "+this.dateService.getFullDate(element.payload.child("to").val()),
          "From": this.dateService.getFullDate(element.payload.child("from").val()),
          "To": this.dateService.getFullDate(element.payload.child("to").val()),
          "Days": this.dateService.getDayDifference(new Date(element.payload.child("to").val()),new Date(element.payload.child("from").val())),
          "Type": element.payload.child("leaveType").val(),
          "Status": element.payload.child("status").val(),
          "Comments": element.payload.child("comments").val(),
          "id": element.key
        };
        this.myLeavesListGrid.push(object);
        if(this.dateService.getDayDifference(new Date(),new Date(element.payload.child("requestedOn").val())) <= 30)
        {
          this.gridDataFor30days.push(object);
        }
        this.gridDataFor30days.sort(function(a,b){
          var c = new Date(a.RequestedOnDate);
          var d = new Date(b.RequestedOnDate);
          return d.getTime() - c.getTime();  
          });
    }); 
    //this.loadItem("search",this.gridDataFor30days);
    this.loadItemSearchResult();
  });
}
public onToggle(id): void {
  this.show = !this.show;
  if(id != this.clickedId)
  {
    this.show = true;
  }
  this.clickedId = id;
}
public onToggleAdminPopup(id): void {
  this.showPopup = !this.showPopup;
  if(id != this.clickedId)
  {
    this.showPopup = true;
  }
  this.clickedId = id;
}

public onClickDropDownList(event,id)
{
  //console.log("id",event.target.id,id);
  this.show = false;
  this.edit = false;
  if(event.target.id ==0)
  {
    this.edit = true;
    this.leaveId = id;
    this.hrmsService.getMyLeaveData(id).once("value").then((leave)=>{
      this.myForm.controls["from"].setValue(new Date(leave.child("from").val()));
      this.myForm.controls["to"].setValue(new Date(leave.child("to").val()));
      this.myForm.controls["comments"].setValue(leave.child("comments").val());
      this.myForm.controls["leaveType"].setValue(leave.child("leaveType").val());
      this.myForm.get('documentUrl').clearValidators();
      this.myForm.get('documentUrl').updateValueAndValidity();
      this.myForm.controls["status"].setValue(leave.child("status").val());
    });
    this.leavesModal.show();
    this.clickedId = null;
  }
  else
  {
    this.hrmsService.cancelLeave(id).then(()=>{
      this.clickedId = null;
    });
  }
}
private updateLeave(data)
{
  this.hrmsService.updateLeave(this.leaveId,data).then(()=>{
    this.currentUpload = null;
    this.leavesModal.hide();
    this.submitted = false;
    this.myForm.reset();
    this.edit = false;
    this.selectedFiles = null;
    this.setFormValues();
  });

}
setFormValues(){
  this.myForm.get("from").setValue(this.bsValue);
    this.myForm.get("to").setValue(this.bsValue);
    this.myForm.get("status").setValue('Pending');
}
onValueChange(value: Date): void {
  if(value!=null)
  {
    this.toMinDate.setDate(value.getDate()+1);
  }
}
clearSearch(from)
{
  
  if(from === 'search')
  {
    this.isSearch = false;
    this.searchForm.reset();
    //this.myLeavesListGrid = this.myLeavesList;
    this.loadItem("search",this.gridDataFor30days);
  }
  else
  {
    this.isSearchAdmin = false;
    this.adminSearchForm.reset();
  //this.myLeavesListGrid = this.myLeavesList;
  this.loadItem("admin_search",this.gridDataOfEmployeesFor30days);
  }
  
}
getEmployeesLeaveList()
{
  this.hrmsService.getEmployeesLeaveList().snapshotChanges().subscribe((data)=>{
    this.employeeLeavesListGrid = [];
    this.gridDataOfEmployeesFor30days = [];
    data.forEach((element)=>{
          this.userService.getUser(element.payload.child("uid").val()).once("value",user=>{
            if(user.val() !=null && user.child("boardingStatus").val() == "onboard")
            {
              var object = {
                "Name": user.child("firstName").val() +" "+ user.child("lastName").val(),
                "Department": this.departments[user.child("department").val()],
                "designation":user.child("designation").val(),
                "department":user.child("department").val(),
                "EmployeeId": user.child("employeeId").val(),
                "RequestedOn": this.dateService.getFullDate(element.payload.child("requestedOn").val()),
                "RequestedOnDate": element.payload.child("requestedOn").val(),
                "LeavePeriod": this.dateService.getFullDate(element.payload.child("from").val()) +" - "+this.dateService.getFullDate(element.payload.child("to").val()),
                "From": this.dateService.getFullDate(element.payload.child("from").val()),
                "To": this.dateService.getFullDate(element.payload.child("to").val()),
                "Days": this.dateService.getDayDifference(new Date(element.payload.child("to").val()),new Date(element.payload.child("from").val())),
                "Type": element.payload.child("leaveType").val(),
                "Status": element.payload.child("status").val(),
                "Comments": element.payload.child("comments").val(),
                "id": element.key
              };
            this.employeeLeavesListGrid.push(object);
            if(this.dateService.getDayDifference(new Date(),new Date(element.payload.child("requestedOn").val())) <= 30)
            {
              this.gridDataOfEmployeesFor30days.push(object);
            }
            this.gridDataOfEmployeesFor30days.sort(function(a,b){
              var c = new Date(a.RequestedOnDate);
              var d = new Date(b.RequestedOnDate);
              return d.getTime() - c.getTime();  
              });
            //this.loadItem("admin_search",this.gridDataOfEmployeesFor30days);
            this.loadItemAdminSearchResult();
          }
          });
    });
  });
}

public getAllDepartments()
{
  var x = this.hrmsService.getAllDepartments();
  x.snapshotChanges().subscribe(item=>{
  this.departmentsOptions = [];
  this.departments = [];
    item.forEach(element =>{
      this.departments[element.key] = element.payload.child("name").val();
        this.departmentsOptions.push({label: String(element.payload.child("name").val()), value: String(element.key)});
    });
  });
}
public getAllDesignations()
{
  var x = this.hrmsService.getAllDesignations();
  x.snapshotChanges().subscribe(item=>{
  this.designationsOptions = [];
  this.designations = [];
    item.forEach(element =>{
      this.designations[element.key] = element.payload.child("name").val();
        this.designationsOptions.push({label: String(element.payload.child("name").val()), value: String(element.key)});
    });
  });
}
onClickDropDownListForAdmin(event,id)
{
  //console.log("id popup",event.target.id,id);
  this.showPopup = false;
  this.leaveId = id;
  switch(event.target.id)
  {
    case "0":
    this.hrmsService.acceptLeaveRequest(id,"Approved").then(()=>{
      //console.log("Accepted");
      this.clickedId = null;
      this.hrmsService.changeLeaveNotifStatus(this.leaveId);
      this.onSubmitAdminSearch();
    });
    break;
    case "1":
    this.hrmsService.acceptLeaveRequest(id,"Rejected").then(()=>{
      //console.log("Rejected");
      this.clickedId = null;
      this.hrmsService.changeLeaveNotifStatus(this.leaveId);
      this.onSubmitAdminSearch();
    });
    break;
    case "2":
    this.hrmsService.acceptLeaveRequest(id,"Pending").then(()=>{
      //console.log("Pending");
      this.clickedId = null;
      this.hrmsService.changeLeaveNotifStatus(this.leaveId);
      this.onSubmitAdminSearch();
    });
    break;
  }
}
public onSubmitSearch()
{
  this.isSearch = true;
  this.searchResult = filterBy(this.myLeavesListGrid, {
    logic: 'or',
    filters: [
        { field: "Status", operator: "eq", value: this.searchForm.value.status},
        { field: "From", operator: "eq", value: this.dateService.getFullDate(this.searchForm.value.from)},
        { field: "To", operator: "eq", value: this.dateService.getFullDate(this.searchForm.value.to)}
    ]
});
//this.loadItem('search',result);
this.loadItemSearchResult();
}
loadItemSearchResult()
{
  if(this.isSearch)
  {
    this.gridView = {
      data: this.searchResult.slice(this.skip1, this.skip1 + this.pageSize),
      total: this.searchResult.length
    };
  }
  else
  {
    this.gridView = {
      data: this.gridDataFor30days.slice(this.skip1, this.skip1 + this.pageSize),
      total: this.gridDataFor30days.length
    };
  }
  
}
public onSubmitAdminSearch()
{
  //console.log("date",this.adminSearchForm.value.from,this.adminSearchForm.value.to);
  this.isSearchAdmin = true;
  this.adminSearchResult = filterBy(this.employeeLeavesListGrid, {
    logic: 'or',
    filters: [
        { field: "Status", operator: "eq", value: this.adminSearchForm.value.status},
        { field: "From", operator: "eq", value: this.dateService.getFullDate(this.adminSearchForm.value.from)},
        { field: "To", operator: "eq", value: this.dateService.getFullDate(this.adminSearchForm.value.to)},
        { field: "department", operator: "eq", value: this.adminSearchForm.value.department},
        { field: "designation", operator: "eq", value: this.adminSearchForm.value.designation},
        { field: "EmployeeId", operator: "eq", value: this.adminSearchForm.value.name}
    ]
});
//this.loadItem('admin_search',result);
this.loadItemAdminSearchResult();
}
loadItemAdminSearchResult()
{
  if(this.isSearchAdmin)
  {
    this.gridViewAllLeaveList = {
      data: this.adminSearchResult.slice(this.skip2, this.skip2 + this.pageSize),
      total: this.adminSearchResult.length
    };
  }
  else
  {
    this.gridViewAllLeaveList = {
      data: this.gridDataOfEmployeesFor30days.slice(this.skip2, this.skip2 + this.pageSize),
      total: this.gridDataOfEmployeesFor30days.length
    };
  }
}
private loadItem(type,data):void{
  if(type == "search")
  {
  this.gridView = {
    data: data.slice(this.skip1, this.skip1 + this.pageSize),
    total: data.length
  };
}
else
{
  this.gridViewAllLeaveList = {
    data: data.slice(this.skip2, this.skip2 + this.pageSize),
    total: data.length
  };
}
}
public getAllEmployees()
  {
  var x = this.userService.getAllUser();
  x.snapshotChanges().subscribe(item=>{
    this.myEmployees = [];
    item.forEach(element =>{
      var y = element.payload.toJSON();
      if(!(element.payload.child("role").val() == "customer"))
      {
        y["$key"] = element.key;
        this.myEmployees.push({label: String(element.payload.child("name").val()), value: String(element.payload.child("employeeId").val())});
      }
    });
  });
}
onCloseApplyLeave()
{
  this.myForm.reset();
  this.setFormValues();
  this.ApplyLeaveModal.hide();
}
public pageChange(event: PageChangeEvent): void {
  this.skip1 = event.skip;
  this.loadItemSearchResult();
}
public pageChangeAdmin(event: PageChangeEvent): void {
  this.skip2 = event.skip;
  this.loadItemAdminSearchResult();
}
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/leaves/leaves.component.ts